<div class="modal" tabindex="-1" role="dialog" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="pagetitle"></h4>
        <i class="material-icons download-icon" >file_download</i>
        <span class="table-material-icons" role="button" (click)="activeModal.dismiss('Cross click')" (keydown)="activeModal.dismiss('Cross click')" tabindex="0">
          close</span>
      </div>
      <div class="modal-body">
        <div>
          <p>Download the Excel Template with data </p>
        </div>
        <div class="button-container">
          <app-button size="medium" buttonType="primary" (click)="onDownload()" (keydown)="onDownload()">
            Download File
          </app-button>
        </div>
        <div class="label-container">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-box" [(ngModel)]="isLegacyDownload"/>
            <span>Download the legacy version of the current premium sheet</span>
          </label>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>